export default __webpack_public_path__ + "static/media/jasmine_and_ian-0466_tn.80ddb71b.jpg";